export default function (val) {
  return val.replace(/[\uffe5\$]/, '')
}
